/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define(['../../../lib/@waca/dashboard-common/dist/core/APIFactory',
	'../../../features/dashboard/userProfile/UserProfileAPI'
], (APIFactory, UserProfileAPI) => {

	/**
	 * @class
	 * @implements UserProfileAPI
	 * @hideconstructor
	 * @classdesc default implementation of the UserProfileAPI
	 */
	class CAUserProfile {

		constructor() {
			this._api = APIFactory.createAPI(this, [UserProfileAPI]);
		}

		getAPI() {
			return this._api;
		}

		/**
		 * Glass initialize method for services
		 * @param {Object} glassContext
		 */
		initialize(glassContext) {
			this._userProfile = glassContext.getCoreSvc('.UserProfile');
			this._config = glassContext.getCoreSvc('.Config');
			return this._config.getConfigValue('ClientValidDomainList')
				.then( (list) => { this._validDomainList = list; });
		}

		/**
		 *
		 * @param {string} capabilityName
		 * @returns {boolean} true/false based on CM capabilities
		 */
		hasCapability(capabilityName) {
			return this._userProfile.capabilities.indexOf(capabilityName) != -1;
		}

		getValidDomainList() {
			return this._validDomainList;
		}

		/**
		 * @returns {string} user content locale. Defaults to 'en'
		 */
		getContentLocale(){
			const userPreferences = this._userProfile && this._userProfile.preferences;
			return userPreferences && userPreferences.contentLocale || 'en';
		}

		getProductLocale(){
			const userPreferences = this._userProfile && this._userProfile.preferences;
			return userPreferences && userPreferences.productLocale || 'en';
		}

		getAvailableContentLocales(){
			return this._config.getContentLocales();
		}

		getUserAccount() {
			const userAccount = this._userProfile.userAccount;
			return {
				defaultName: userAccount && userAccount.defaultName,
				userName: userAccount && userAccount.userName,
				id: userAccount && userAccount.id,
				email: userAccount && userAccount.email
			};
		}
	}

	return CAUserProfile;
});
